module.exports = __webpack_public_path__ + "img/linse_vaniljecreme.20334ef3.jpg";